@if (result) {
  <div class="result" [class.active]="active" (mouseenter)="activate()" (click)="rowClicked()" [class.disabled]="disabled">
    <div class="result__content" [attr.data-testid]="'option-' + result.name | slugify">
      <p class="result__name">{{ result.name }}</p>
      @if (result.subtitle) {
        <p class="result__subtitle">{{ result.subtitle }}</p>
      }
    </div>
  </div>
}
